import { FooterNavigationGroup } from './FooterNavigationGroup'
import { LowerFooter } from '@components/Footer/LowerFooter'
import type { GetFooterType as FooterDataProps } from '@helpers/getFooter'

type FooterProps = {
  data: FooterDataProps
  showFooterNavigation?: boolean
}

export const Footer = ({ data, showFooterNavigation }: FooterProps) => {
  return (
    <footer role='contentinfo'>
      {showFooterNavigation && <FooterNavigationGroup data={data.mainFooter} />}
      <LowerFooter data={data.colophonData} />
    </footer>
  )
}
